import React, { useState, useEffect } from "react";
import "../styles.css";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarRating from "./UserPatientScreen/StarRating";
import { API_IP } from "../global_variables";

const CareServiceCard = ({ service, setSelectedSection }) => {
  const [userRating, setUserRating] = useState(0);
  const navigate = useNavigate();
  const imgList = {
    "Personal Care Service": 1,
    "Companionship and Outings": 2,
    "House Hold Support": 3,
    "Support for Daily Living": 4,
    "Technology Support": 5,
  };

  return (
    <button
      onClick={() => {
        navigate(`/CareServiceProfile?id=${service.care_service_id}`, {
          state: {
            data: service,
            imgIndex: imgList[service.care_service_name] || 1,
          },
        });
      }}
      className="careProviderCardLink"
    >
      <div className="careServiceCard">
        <div className="care-service-img-container">
          <img
            src={require(
              `../images/care_service_${
                imgList[service.care_service_name]
              }.png`,
            )}
            alt={service.care_service_name}
            className="care-service-img"
          />
        </div>
        <div className="careServiceTitle">
          <p>{service.care_service_name}</p>
        </div>
        <div className="careServiceDescription">
          <p>{service.description}</p>
        </div>
        {/* <div className="listStyleNone textWeight300">
          Hours: {provider.opening_hour}:00 - {provider.closing_hour}
          :00
        </div>

        <div className="listStyleNone textWeight300">{provider.email}</div> */}
      </div>
    </button>
  );
};

const ServiceSelection = ({ setSelectedSection, services }) => {
  return (
    <>
      <div className="providerSelectionContainer">
        <div className="titleContainer">
          <h1>Care Services</h1>
          <h3>
            Personalized, non-medical home care delivered by trusted iCare
            Village caregivers – right where you live
          </h3>
        </div>

        <div className="careProviderListContainer">
          <div className="careProviderList">
            {services.map((service, index) => (
              <div className="care-service-card-container">
                <CareServiceCard
                  key={index}
                  service={service}
                  setSelectedSection={setSelectedSection}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceSelection;
